var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindPower01 = function SvgWindPower01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "wind-power-01_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wind-power-01_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.018 9.878c.175 0 .33.039.486.117.175-.331.312-.837.312-1.615 0-1.772-.35-4.847-.798-4.847-.448 0-.798 3.075-.798 4.847 0 .76.156 1.285.312 1.615.156-.078.311-.116.486-.117Zm-1.052 1.09c-.37.02-.896.137-1.558.526-1.537.876-4.01 2.725-3.796 3.115.214.389 3.057-.857 4.594-1.733.662-.389 1.032-.76 1.226-1.07a1.111 1.111 0 0 1-.466-.838Zm2.083 0c.37.02.895.137 1.557.526 1.536.895 4.029 2.744 3.776 3.094-.214.39-3.057-.856-4.594-1.732-.662-.37-1.013-.759-1.226-1.07a.99.99 0 0 0 .487-.818Zm-1.032.994c-.156 0-.292-.039-.429-.098l-.37 8.41s.332.194.799.194.798-.194.798-.194l-.37-8.41a.816.816 0 0 1-.428.098Zm.001-.6a.432.432 0 1 0 0-.865.432.432 0 0 0 0 .865Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wind-power-01_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgWindPower01 as ReactComponent };